import React from 'react';
import styles from './Registration.module.scss';

const Registration = ()=> (
    <div>
        <h2>Registration</h2>
        <p><b>Please note: To be published in the DSLW 2022 Conference Proceedings and IEEE Xplore®, an author of an accepted paper must register for the conference at the full (member or non-member) rate.</b></p>
        <p>Non-refundable registration fees must be paid prior to the author registration deadline. The deadline for author registration is <b>Mar 31, 2022</b> at 11:59 PST. Failure to have such registration will result in the removal of the paper from the Technical Program.</p>
        <p>For authors with multiple accepted papers, one registration can cover up to 2 papers. Accepted and presented papers will be published in the DSLW 2022 Conference Proceedings and submitted to IEEE Xplore®.</p>
        <p>One must be an IEEE Member at the time of registration to receive the IEEE Member discount. Please visit <a href="https://www.ieee.org/membership/join/index.html" target="_blank">ieee.org/join</a> for more details.</p>
        <p>The table below shows registration fees in US Dollar (USD):</p>

        <table>
          <tr>
            <th>Registration Types</th>
            <th>Rates</th>
          </tr>
          <tr>
            <td>Advance Non-Member (full)</td>
            <td>240</td>
          </tr>
          <tr>
            <td>Advance IEEE Member (full)</td>
            <td>210</td>
          </tr>
          <tr>
            <td>Advance SPS Member (full)</td>
            <td>180</td>
          </tr>
          <tr>
            <td>Low Income Economy Countries (full)</td>
            <td>150</td>
          </tr>
          <tr>
            <td>Virtual Attendee Non-Member</td>
            <td>90</td>
          </tr>
          <tr>
            <td>Virtual Attendee IEEE Member</td>
            <td>50</td>
          </tr>
          <tr>
            <td>Virtual Attendee SPS Member</td>
            <td>40</td>
          </tr>
          <tr>
            <td>Virtual Attendee Student Non-Member</td>
            <td>25</td>
          </tr>
          <tr>
            <td>Virtual Attendee Student IEEE Member</td>
            <td>0</td>
          </tr>
        </table>
        <p></p>
        <p>Please use the following link for registration: </p>
        <p><a href="https://www.conftool.net/dslw2022" target="_blank">https://www.conftool.net/dslw2022</a></p>
        <p>(You will need to create an account first. If you have any question regarding the registration process, please contact us at <a href="mailto:dslw2022@conftool.net">dslw2022@conftool.net</a>)</p>
        <p>If you are an IEEE Student Member who is a virtual attendee, your registration for DSLW 2022 will be free. Please still follow the above registration link to finish the registration procedure so that your contact information and your student registration status will be recorded, though you will not need to make a payment.  </p>
    </div>
);

export default Registration;